import React from 'react';
import { Redirect, useLocation } from 'react-router-dom';

/**
 * 受保护路由：未认证时重定向到登录页。
 * 使用 React.Fragment 包裹 children，保证每次渲染返回稳定的元素类型，不打断 React 渲染周期。
 */
export default function ProtectedRoute({ children }) {
  const location = useLocation();
  const isAuthenticated =
    sessionStorage.getItem('trade_authenticated') === 'true' ||
    localStorage.getItem('trade_authenticated') === 'true';

  if (!isAuthenticated) {
    return (
      <Redirect to={{ pathname: '/login', state: { from: location } }} />
    );
  }

  return <>{children}</>;
}